import { BetaBadge } from "PFApp/components/beta_badge";
import { Button } from "PFComponents/button";
import { Tooltip } from "PFComponents/tooltip";
import { Id } from "PFTypes";
import { useTranslation } from "react-i18next";
import { createSearchParams, useNavigate } from "react-router";

type ManageRolesButtonProps = {
  engagementId: Id;
};

export const ManageRolesButton = ({ engagementId }: ManageRolesButtonProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "manageRoles" });
  const navigate = useNavigate();

  const handleClick = () => {
    navigate({
      pathname: "/activities/manage_roles",
      search: `?${createSearchParams({ engagementIds: JSON.stringify([engagementId]) })}`
    });
  };

  return (
    <Tooltip content={t("betaTooltip")}>
      <Button kind="secondary" aria-label={t("betaTooltip")} onClick={handleClick}>
        <span>{t("title")}</span>
        <BetaBadge />
      </Button>
    </Tooltip>
  );
};
